import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../translations/translations";
import AnimatedCounter from "./AnimatedCounter";

const HeroSection = () => {
  const { language } = useLanguage();

  const slides = [
    {
      titleKey: "hero.slide1Title",
      subtitleKey: "hero.slide1Subtitle",
      image: "Education.png",
    },
    {
      titleKey: "hero.slide2Title",
      subtitleKey: "hero.slide2Subtitle",
      image: "manage.png",
    },
    {
      titleKey: "hero.slide3Title",
      subtitleKey: "hero.slide3Subtitle",
      image: "hero apps.png",
    },
  ];

  const stats = [
    { number: "300+", labelKey: "hero.institutions" },
    { number: "150K+", labelKey: "hero.studentsManaged" },
    { number: "99%", labelKey: "hero.satisfactionRate" },
  ];

  return (
    <section className="hero-section" id="home">
      <div
        id="heroCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>

        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div className="container h-100">
                <div
                  className="row align-items-center"
                  style={{ minHeight: "calc(100vh - 500px)" }}
                >
                  <div className="col-lg-8 col-xl-7">
                    <div
                      className="hero-content p-2 pb-3"
                      data-aos="fade-right"
                      data-aos-delay="100"
                    >
                      <h1 data-aos="fade-up" data-aos-delay="200">
                        {getTranslation(language, slide.titleKey)}
                      </h1>
                      <p data-aos="fade-up" data-aos-delay="300">
                        {getTranslation(language, slide.subtitleKey)}
                      </p>
                      <div
                        className="hero-buttons"
                        data-aos="fade-up"
                        data-aos-delay="400"
                      >
                        <a href="#contact" className="btn btn-hero-primary">
                          <i className="bi bi-telephone me-2"></i>
                          {getTranslation(language, "contact.bookDemo")}
                        </a>
                        <a href="#modules" className="btn btn-hero-outline">
                          <i className="bi bi-play-circle me-2"></i>
                          {getTranslation(language, "modules.view")}
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* Hero Image */}
                  <div
                    className="col-lg-4 col-xl-5 tab-rel"
                    data-aos="zoom-in"
                    data-aos-delay="200"
                  >
                    <img
                      src={slide.image}
                      alt="Hero Illustration"
                      className="img-fluid hero-float-image"
                    />
                    {/* Stats Row */}
                    <div className="stats-row mb-5 d-lg-none">
                      {stats.map((stat, idx) => (
                        <div key={idx} className="stat-badge">
                          <AnimatedCounter
                            target={stat.number}
                            label={getTranslation(language, stat.labelKey)}
                            duration={2000}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="d-none d-lg-flex flex-row gap-4 pb-4 mx-auto justify-content-center">
                  {stats.map((stat, idx) => (
                    <div
                      key={idx}
                      className="col-md-4 mb-3 mb-md-0"
                      data-aos="fade-up"
                      data-aos-delay={100 + idx * 100}
                    >
                      <div className="stat-card">
                        <AnimatedCounter
                          target={stat.number}
                          label={getTranslation(language, stat.labelKey)}
                          duration={2000}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
